import httpHelper from 'Services/HttpHelper'
import { ServerEnv } from 'Configs/ServerEnv'
const GetProducts = ({ status = 'C' }) => {
    const url = `${ServerEnv.MemberCalls2()}/products-v2/publish/THA?allow=shop&status=${status}&warehouse=Main`

    return httpHelper.Get({
        url: url,
        config: {
            headers: {
                'Content-Type': 'application/json'
            }
        }
    })
}

const getHotFormatV2 = (uuid, countryCode3Alpha, calc) => {
    const url = `${ServerEnv.MemberCalls2()}/hot/format/${countryCode3Alpha}/feelGreatUfg/detail-v2/${uuid}`

    let queryStrings = {}

    if (ServerEnv.ENV === 'DEV') {
        queryStrings.isCalculateInQa = 1
    }
    if (calc) {
        queryStrings.ordercalC = 1
    }

    return httpHelper.Get({
        url: url,
        config: {
            headers: {
                'Content-Type': 'application/json'
            },
            params: queryStrings
        }
    })
}

const putHotFormatV2 = (data, countryCode3Alpha) => {
    const url = `${ServerEnv.MemberCalls2()}/hot/formatV2/${countryCode3Alpha}/feelGreatReferral/address`
    return httpHelper.Put({
        url: url,
        data
    })
}

const checkDuplicateOrder = ({ countryCode3Alpha, uuid }) => {
    const url = `${ServerEnv.MemberCalls2()}/hot/payment_router/duplicateOrder/${countryCode3Alpha}/feelGreatUfg/${uuid}`

    return httpHelper.Get({
        url: url
    })
}

const verifyTokenRecaptchaV3 = googleToken => {
    const url = `${httpHelper.Proxy({
        originalUrl: `https://member-calls2.unicity.com/bot-protection/recaptchaV3/verify`
    })}`
    // The backend's test flags, driven from the URL so the v2 fallback can be exercised without
    // editing this file - and so the flag can never be committed on by accident.
    // Add ?is_bot=1 to fail the check outright, or ?is_random_score=1 for a random score.
    // Safe to leave live: both only make the check stricter, never weaker.
    const qs = new URLSearchParams(window.location.search)

    const data = {
        ...(qs.get('is_bot') === '1' && { is_bot: true }),
        ...(qs.get('is_random_score') === '1' && { is_random_score: true }),
        g_token: googleToken
    }

    return httpHelper.Post({
        url: url,
        data
    })
}

export const ReferralUaeAPIs = {
    GetProducts,
    getHotFormatV2,
    putHotFormatV2,
    checkDuplicateOrder,
    verifyTokenRecaptchaV3
}
